/**
 * Pone la cocarda de OFERTA arriba a la izquierda de la foto de la ficha.
 *
 * 🔴 LA DIBUJA LIQUID, ACA SOLO SE LA MUEVE. El porcentaje sale del precio de
 *    verdad en el servidor; si este archivo no carga, no aparece nada — que es
 *    mejor que una cocarda con un numero inventado.
 *
 * 🔴 VA EN `.product-media-container`, que es `position: relative` y NO recorta.
 *    `.product__media` tambien es relativo pero tiene `overflow: hidden`: ahi la
 *    cocarda quedaria cortada si algun dia se la corre hacia afuera del borde.
 *
 * 🔴 ARRIBA A LA IZQUIERDA. En la grilla el corazon de la lista de deseos vive
 *    arriba a la derecha; aunque en la ficha no este, se respeta el mismo lado
 *    para que la esquina derecha siga significando «guardar» en todo el sitio.
 */
(function () {
  function poner() {
    var c = document.querySelector('.ama-oferta');
    if (!c || c.dataset.ama) return;
    var caja = document.querySelector('.product-media-container');
    if (!caja) return;
    caja.appendChild(c);
    c.dataset.ama = '1';
    c.hidden = false;
  }
  function iniciar() {
    poner();
    // la galeria se redibuja al cambiar de variante
    new MutationObserver(poner).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
